import { WALL_ID } from '../keys'
const initialState = { wallID: null }
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case WALL_ID: {
            return { ...state, wallID: action.payload }
        }
        default:
            return { ...state }
    }

}